// Route entry-point for Spår 3 delspår 3a wizard.
// Pure delegate to ActivityWizard component. <ProtectedRoute> handles auth-guard.

import ActivityWizard from "@/components/activity/wizard/ActivityWizard";

export default function SkapaAktivitet() {
  return <ActivityWizard />;
}
